<main class="navigation-footer w-100 d-flex flex-column justify-content-center">
    <section class="row g-0">
        <div class="brand-logo col-lg-3 d-flex flex-column body-4-lg align-items-center align-items-lg-start"
            >
            <img (click)="scrollToTop()" alt="Qeleo Logo" class="qeleo-logo" routerLink="/home"
                src="../../../../assets/images/qeleo-logo.svg">
            <div class="primary-text d-flex flex-column align-items-center align-items-lg-start">
                <span>Copyright © 2023 Qeleo, Inc.</span>
                <span>All rights reserved. <a (click)="scrollToTop()" routerLink="/legal" class="q-purple-s-text terms-link text-decoration-none">Terms &
                        Conditions.</a></span>
            </div>
        </div>
        <div class="col-lg-3 d-flex justify-content-center">
            <div class="navigation-links d-flex flex-column gap-3 align-items-center align-items-lg-start">
<!--                <a (click)="scrollToTop()" class="h5-lg text-decoration-none router-link secondary-text" routerLinkActive="active"-->
<!--                    routerLink="/products">/Products</a>-->
                <a (click)="scrollToTop()" class="h5-lg text-decoration-none router-link secondary-text" routerLinkActive="active"
                    routerLink="/consultancy">/Consultancy</a>
                <a (click)="scrollToTop()" class="h5-lg text-decoration-none router-link secondary-text" routerLinkActive="active"
                    routerLink="/pricing">/Pricing</a>
                <a (click)="scrollToTop()" class="h5-lg text-decoration-none router-link secondary-text" routerLinkActive="active"
                   routerLink="/insights">/Insights</a>
            </div>
        </div>
        <div class="col-lg-3 d-flex justify-content-center">
            <div class="navigation-links d-flex flex-column gap-3 align-items-center align-items-lg-start">
                <a (click)="scrollToTop()" class="h5-lg text-decoration-none router-link secondary-text" routerLinkActive="active"
                    routerLink="/ethics">/Ethics</a>
                <a (click)="scrollToTop()" class="h5-lg text-decoration-none router-link secondary-text" routerLinkActive="active"
                    routerLink="/about">/About</a>
<!--                <a (click)="scrollToTop()" class="h5-lg text-decoration-none router-link secondary-text" routerLinkActive="active"-->
<!--                    routerLink="/investor">/Investor Relations</a>-->
<!--                <a (click)="scrollToTop()" class="h5-lg text-decoration-none router-link secondary-text" routerLinkActive="active"-->
<!--                    routerLink="/work">/Work with us</a>-->
            </div>
        </div>
        <div class="social-icons col-lg-3 d-flex gap-3 justify-content-center justify-content-lg-end">
            <a href="https://www.linkedin.com/company/qeleo" class="text-decoration-none" target="_blank">
                <img class="icon" src="../../../../assets/images/linkedin-icon.svg">
            </a>
        </div>
    </section>
    <div class="primary-text text-center footer-text">
        Site created with <span><img class="heart-icon" src="../../../../assets/images/heart-icon.svg"></span>
        by <a href="https://qeleo.ai/" target="_blank" class="q-blue-p-text link">Qeleo AI</a> and <span class="q-blue-p-text">Qeleo humans</span>.
    </div>
</main>
